import {
  graphQlAll
}
  from "@/api/api";
export default {
  namespaced: true,
  actions: {

    // graphQlAll
    async graphQlAll(context, params) {
      let query = 'query';
      const requiredLogin = params.requiredLogin;
      const queryParams = params.params;
      const queryApi = params.api;
      const result = params.result;
      let queryChild1 = '';
      let queryChild2 = '';
      if (!!queryParams) {
        const keys = Object.keys(queryParams);
        queryChild1 = '(';
        queryChild2 = '(query:{';
        keys.forEach((item,index) => {
          // 非第一个参数 添加逗号分隔符
          if(index !== 0) {
            queryChild1 = queryChild1 + ',';
            queryChild2 = queryChild2 + ',';
          }
          if(typeof(queryParams[item])=='number'){
            queryChild1 = queryChild1 + '$' + item + ':Int';
          }else {
            queryChild1 = queryChild1 + '$' + item + ':String';
          }
          queryChild2 = queryChild2 + item + ':$' + item;
          // 最后一个参数 添加结尾
          if (index === keys.length - 1) {
            queryChild1 = queryChild1 + ')';
            queryChild2 = queryChild2 + '})';
          }
        })
      }
      query = `${query}${queryChild1}{${queryApi}${queryChild2}{${result}}}`;
      const reqParam = { 'query':query, 'variables':queryParams || {}, 'requiredLogin':requiredLogin }
      const { data } = await graphQlAll(reqParam);
      return data[queryApi];
    },

  }
}
